import React, { useState, useEffect } from 'react';
import firebaseConfig from '../config/firebase';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import LoadingScreen from '../components/loadingScreen';

export const AuthContext = React.createContext();
export const AuthProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);
  // const [token, setToken] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(getAuth(firebaseConfig), async (user) => {
      // console.log(user);
      if (user) {
        localStorage.setItem('access', user.accessToken);
        setCurrentUser(user);
      }
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  if (loading) {
    return (
      <>
        <LoadingScreen />
      </>
    );
  }

  return <AuthContext.Provider value={{ currentUser }}>{children}</AuthContext.Provider>;
};
